import styled from "styled-components";

export const WarningBanner = styled('div')`
  background: #EF6C00;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  width: 100%;

  margin: 0px;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const BannerContent = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: center;
  max-width: 1200px;
  width: 100%;
  justify-content: center;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const BannerIcon = styled('span')`
  font-size: 24px;
  flex-shrink: 0;
`;

export const BannerText = styled('div')`
  font-size: 16px;
  color: #ffffff;
  line-height: 1.6;
  font-weight: 500;

  strong {
  font-size: inherit;
    color: #ffffff;
    font-weight: 700;
  }

  a {
  font-size: inherit;
    color: #ffffff;
    text-decoration: underline;
    font-weight: 600;

    &:hover {
      text-decoration: none;
    }
  }

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

